export const shouldRequireHipaaAcceptance = (user: {
  tenantOrganizationId?: string | null;
  patientProfileId?: string | null;
  hipaaStatus?: string | null;
} | null | undefined) => Boolean(user?.tenantOrganizationId && user?.patientProfileId && user?.hipaaStatus !== 'accepted');
